import styles from 'styles/modules/AddContent.module.scss';

const AddContent = (props) => {
    let data = {
        direction: 'column',
        label: 'Add Content',
        onClick: () => {},
        active: false,
        center: false,
    };

    if (props.data) data = { ...data, ...props.data };

    const wantedClasses = [
        styles.wrapper,
        styles[data.direction],
        data.active ? styles.active : null,
        !data.label ? styles.inline : null,
        data.center ? styles.center : null,
    ].join(' ');

    return (
        <div className={wantedClasses} onClick={data.onClick}>
            <div className={styles.plus} />
            {data.label && <div className={styles.label}>{data.label}</div>}
        </div>
    );
};

export default AddContent;
